import React, { useState, useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import Frame222 from "../Frame222";
import jsPDF from "jspdf";
import "./AnalysisBeta.css";

// ==============================
//     CONFIG API
// ==============================
const API_URL =
  process.env.REACT_APP_API_URL;

const MANAGEMENT_KEYWORDS = {
  VSM: "vsm",
  "5S": "5s",
  Kaizen: "kaizen",
  SMED: "smed",
  Kanban: "kanban",
  "Visual Management": "visual",
};

function Analysis(props) {
  const { place, formalismesEnFonct, frame222Props } = props;

  // à‰tats principaux
  const [activeTab, setActiveTab] = useState("acquisition");
  const [activeCase, setActiveCase] = useState(null);
  const [enterpriseScores, setEnterpriseScores] = useState(null);
  const [result, setResult] = useState(null);

  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);

  const [loadingCase, setLoadingCase] = useState(true);
  const [loadingScores, setLoadingScores] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [selectedDomain, setSelectedDomain] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);

  const [selectedManagementTool, setSelectedManagementTool] = useState(null);
  const [selectedManagementFileId, setSelectedManagementFileId] = useState(null);

  const [domainReport, setDomainReport] = useState(null);
  const [domainDetailedReport, setDomainDetailedReport] = useState(null);

  const [modelReport, setModelReport] = useState(null);
  const [managementExpertReport, setManagementExpertReport] = useState(null);

  const [managementAIReport, setManagementAIReport] = useState(null);
  const [aiCaseAnalysis, setAiCaseAnalysis] = useState(null);
  const [aiAcquisitionAnalysis, setAiAcquisitionAnalysis] = useState(null);
  const [aiModelsAnalysis, setAiModelsAnalysis] = useState(null);

  const [graiModels, setGraiModels] = useState([]);
  const [selectedModelId, setSelectedModelId] = useState(null);

  const [modelAnalysisMode, setModelAnalysisMode] = useState("expert"); // "expert" ou "ai"
  const [managementAnalysisMode, setManagementAnalysisMode] = useState("expert"); // "expert" | "ai"

  // ==============================
  // âœ… RULES ENGINE (NEW)
  // ==============================
    // ==============================
  // âœ… RULES CRUD (NEW)
  // ==============================
  const [rulesCatalog, setRulesCatalog] = useState([]);
  const [rulesLoading, setRulesLoading] = useState(false);
  const [rulesError, setRulesError] = useState(null);

  // --- Create form
  const [newRule, setNewRule] = useState({
    rule_type: "model",        // "model" | "management"
    target: "",                // ex: functional, process, environmental...
    code: "",                  // ex: FV_R1
    title: "",
    description: "",
    condition: "{}",           // JSON string
    weight: 1.0,
    enabled: true,
    created_by: "",
  });

  const [createStatus, setCreateStatus] = useState(null);

  // --- Update form (optional but very useful)
  const [selectedRuleId, setSelectedRuleId] = useState("");
  const [editRule, setEditRule] = useState({
    title: "",
    description: "",
    condition: "{}",           // JSON string
    weight: 1.0,
    enabled: true,
  });

  const [updateStatus, setUpdateStatus] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState(null);

  const MODEL_KEYWORDS = {
    "Functional View": "functional",
    "Process View": "process",
    "Physical View": "physical",
    "Decisional View": "decisional",
    "Information Model": "information",
  };

  // IDs stockés localement
  const activeCaseId = localStorage.getItem("caseId");
  const activeEnterpriseId = localStorage.getItem("activeEnterpriseId");
  const token = localStorage.getItem("token");

  // ==============================
  // 1ï¸âƒ£ Chargement du cas actif
  // ==============================
  const fetchActiveCase = useCallback(async () => {
    if (!activeCaseId) {
      setLoadingCase(false);
      setErrorMessage("Aucun cas actif sélectionné.");
      return;
    }

    try {
      setLoadingCase(true);
      const response = await fetch(`${API_URL}/api/case-details/${activeCaseId}`, {
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });

      if (!response.ok) throw new Error("Impossible de charger le cas actif.");

      const data = await response.json();
      if (!data.found) throw new Error("Cas introuvable cà´té serveur.");

      setActiveCase(data.case);

      // ðŸ‘‡ AJOUT OBLIGATOIRE POUR CORRIGER LE SPAM 404
      if (data.case.enterpriseId) {
        localStorage.setItem("activeEnterpriseId", data.case.enterpriseId);
      }
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingCase(false);
    }
  }, [activeCaseId, token]);

  const fetchGraiModels = useCallback(async () => {
    if (!activeEnterpriseId) return;

    try {
      const res = await fetch(`${API_URL}/api/models/${activeEnterpriseId}`);
      if (!res.ok) throw new Error("Impossible de charger les modèles");

      const data = await res.json();
      setGraiModels(data.models || []);
    } catch (err) {
      setErrorMessage(err.message);
    }
  }, [activeEnterpriseId]);

  useEffect(() => {
    fetchGraiModels();
  }, [fetchGraiModels]);

  useEffect(() => {
    if (modelAnalysisMode === "expert") {
      setSelectedModelId(null);
      setAiModelsAnalysis(null);
    } else {
      setSelectedModel(null);
      setModelReport(null);
    }
  }, [modelAnalysisMode]);

  const inferModelType = (filename) => {
    const name = (filename || "").toLowerCase();
    if (name.includes("functional")) return "functional";
    if (name.includes("process")) return "process";
    if (name.includes("physical")) return "physical";
    if (name.includes("decision")) return "decisional";
    if (name.includes("information")) return "information";
    return null;
  };

  // ==============================
  // 2ï¸âƒ£ Chargement des scores
  // ==============================
  const fetchEnterpriseScores = useCallback(async () => {
    if (!activeEnterpriseId) return;

    try {
      setLoadingScores(true);
      const response = await fetch(`${API_URL}/api/enterprise-scores/${activeEnterpriseId}`);

      if (response.status === 404) {
        console.warn("âš ï¸ Aucun score trouvé pour cet ID");
        setEnterpriseScores(null);
        return;
      }

      if (!response.ok) throw new Error("Erreur lors du chargement des scores.");

      const data = await response.json();
      setEnterpriseScores(data);
    } catch (err) {
      console.error("Erreur scores:", err);
      setEnterpriseScores(null);
    } finally {
      setLoadingScores(false);
    }
  }, [activeEnterpriseId]);

  // Chargement initial
  useEffect(() => {
    fetchActiveCase();
    fetchEnterpriseScores();
  }, [fetchActiveCase, fetchEnterpriseScores]);

  // ðŸ”„ Recharge les scores quand le case est chargé
  useEffect(() => {
    if (activeCase?.enterpriseId) fetchEnterpriseScores();
  }, [activeCase, fetchEnterpriseScores]);

  // ==============================
  // 3ï¸âƒ£ UPLOAD IMAGE â€” Acquisition
  // ==============================
  const handleFileUpload = useCallback(async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setUploadStatus("Erreur : fichier non valide.");
      return;
    }

    try {
      setIsUploading(true);
      setUploadStatus("Téléchargement en cours...");

      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(`${API_URL}/upload`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Erreur serveur pendant l'upload.");

      setUploadStatus("Image importée avec succès !");
    } catch (error) {
      setUploadStatus(`Erreur : ${error.message}`);
    } finally {
      setIsUploading(false);
    }
  }, []);

  // ==============================
  // 4ï¸âƒ£ Drag & Drop
  // ==============================
  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (["dragenter", "dragover"].includes(e.type)) setDragActive(true);
    if (e.type === "dragleave") setDragActive(false);
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragActive(false);
      if (e.dataTransfer.files?.[0]) {
        handleFileUpload({ target: { files: e.dataTransfer.files } });
      }
    },
    [handleFileUpload]
  );

  // ==============================
  // 5ï¸âƒ£ Exécution PyKE â€” MODELES
  // ==============================
  const inference = useCallback(async () => {
    try {
      setIsUploading(true);
      setUploadStatus("Analyse PyKE en cours...");
      setResult(null);

      const response = await fetch(`${API_URL}/inferences`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        if (response.status === 404) throw new Error("Aucun fichier trouvé.");
        throw new Error("Erreur backend PyKE.");
      }

      const data = await response.json();
      if (data.errors) setResult(data.errors);
      else if (data.message) setResult([data.message]);
      else throw new Error("Réponse PyKE invalide.");

      setUploadStatus("Analyse terminée !");
    } catch (err) {
      setUploadStatus(`Erreur : ${err.message}`);
    } finally {
      setIsUploading(false);
    }
  }, []);

  const renderAI = (text) => {
    try {
      const obj = JSON.parse(text);
      return <pre className="ai-json-box">{JSON.stringify(obj, null, 2)}</pre>;
    } catch (e) {
      return <pre className="ai-text-box">{text}</pre>;
    }
  };

  const fetchAICaseAnalysis = useCallback(async () => {
    if (!activeCaseId) return;

    try {
      setLoadingScores(true);
      setAiCaseAnalysis(null);

      const response = await fetch(`${API_URL}/api/ai/analyse-case`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ case_id: activeCaseId }),
      });

      if (!response.ok) throw new Error("Erreur IA analyse case");

      const data = await response.json();
      setAiCaseAnalysis(data.analysis);
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingScores(false);
    }
  }, [activeCaseId]);

  const fetchAIAcquisitionAnalysis = useCallback(async () => {
    if (!activeEnterpriseId) return;

    try {
      setLoadingScores(true);
      setAiAcquisitionAnalysis(null);

      const response = await fetch(
        `${API_URL}/api/ai/analyse-acquisition/${activeEnterpriseId}`
      );

      const data = await response.json();

      if (!response.ok) {
        setAiAcquisitionAnalysis("âš ï¸ No acquisition data found for this enterprise.");
        return;
      }

      setAiAcquisitionAnalysis(data.analysis);
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingScores(false);
    }
  }, [activeEnterpriseId]);

  const fetchAIModelsAnalysis = useCallback(async () => {
    if (!selectedModelId) return;

    try {
      setLoadingScores(true);
      setAiModelsAnalysis(null);

      const model = graiModels.find((m) => m._id === selectedModelId);
      if (!model) throw new Error("Model not found");

      const modelType = inferModelType(model.filename);
      if (!modelType) {
        setAiModelsAnalysis("âŒ Type de modèle non reconnu.");
        return;
      }

      const response = await fetch(
        `${API_URL}/api/ai/analyse-model/${model._id}/${modelType}`
      );

      if (!response.ok) throw new Error("Erreur IA modèle");

      const data = await response.json();
      setAiModelsAnalysis(data.analysis);
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingScores(false);
    }
  }, [selectedModelId, graiModels]);

  // ==============================
  // 6ï¸âƒ£ Génération PDF (PyKE)
  // ==============================
  const saveAsPDF = useCallback(() => {
    if (!result?.length) return;

    const pdf = new jsPDF();
    let y = 20;

    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(18);
    pdf.text("Rapport d'Analyse PyKE", 105, y, { align: "center" });

    y += 20;
    pdf.setLineWidth(0.5);
    pdf.line(10, y, 200, y);
    y += 10;

    result.forEach((err, index) => {
      const text = typeof err === "string" ? err : JSON.stringify(err);
      const lines = pdf.splitTextToSize(`${index + 1}. ${text}`, 180);

      if (y + lines.length * 8 > 280) {
        pdf.addPage();
        y = 20;
      }

      pdf.text(lines, 10, y);
      y += lines.length * 8;
    });

    pdf.save("analyse_pyke.pdf");
  }, [result]);

  // ==============================
  // PDF helper (generic)
  // ==============================
  const downloadAnalysisPDF = (title, content) => {
    if (!content) return;

    const pdf = new jsPDF("p", "mm", "a4");
    const marginX = 15;
    let y = 20;
    const pageHeight = pdf.internal.pageSize.height;

    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(18);
    pdf.text(title, marginX, y);

    y += 10;
    pdf.setLineWidth(0.5);
    pdf.line(marginX, y, 195, y);
    y += 10;

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(12);

    const lines = pdf.splitTextToSize(content, 180);
    lines.forEach((line) => {
      if (y > pageHeight - 15) {
        pdf.addPage();
        y = 20;
      }
      pdf.text(line, marginX, y);
      y += 7;
    });

    pdf.save(`${title.replace(/\s+/g, "_").toLowerCase()}.pdf`);
  };

  // ==============================
  // 7ï¸âƒ£ RENDU DES SECTIONS
  // ==============================
  const fetchFullAcquisitionReport = useCallback(async () => {
    if (!selectedDomain || !activeEnterpriseId) return;

    try {
      setLoadingScores(true);
      setDomainReport(null);
      setDomainDetailedReport(null);

      const detailedRes = await fetch(
        `${API_URL}/expert/evaluate?enterpriseId=${activeEnterpriseId}&domain=${encodeURIComponent(
          selectedDomain
        )}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify([]),
        }
      );

      if (!detailedRes.ok) throw new Error("Erreur Detailed Report");

      const detailedData = await detailedRes.json();
      setDomainDetailedReport(detailedData.mongo_data || []);

      const score = detailedData.score || 0;

      const globalRes = await fetch(
        `${API_URL}/expert/global-report?domain=${encodeURIComponent(
          selectedDomain
        )}&score=${score}`
      );

      if (!globalRes.ok) throw new Error("Erreur Global Report");

      const globalData = await globalRes.json();
      setDomainReport(globalData);
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingScores(false);
    }
  }, [selectedDomain, activeEnterpriseId]);

  const buildAcquisitionPDFContent = () => {
    if (!domainReport) return "";

    let content = `
Domain: ${domainReport.domain}
Score: ${domainReport.score}

Global Analysis:
${domainReport.global_message}
`.trim();

    if (domainDetailedReport && domainDetailedReport.length > 0) {
      content += "\n\nDetailed Analysis:\n";
      domainDetailedReport.forEach((item, index) => {
        content += `
${index + 1}. Question: ${item.question}
Answer: ${item.answer}
Suggestion: ${item.suggestion}
`.trim();
        content += "\n\n";
      });
    }

    return content.trim();
  };

  const renderAcquisition = () => (
    <section className="analysis-section">
      <h3 className="section-title"> Acquisition</h3>
      <p className="section-subtitle">Choose a domain to analyse.</p>

      <div className="acq-buttons-grid">
        {[
          "Environmental",
          "Social",
          "Modernization",
          "Lead Time",
          "Cost",
          "Quality",
          "Client Consumer",
        ].map((domain) => (
          <button
            key={domain}
            className={`acq-btn ${selectedDomain === domain ? "active" : ""}`}
            onClick={() => setSelectedDomain(domain)}
          >
            {domain}
          </button>
        ))}
      </div>

      {selectedDomain && (
        <div className="report-section">
          <div className="report-header">
            <span className="report-icon"></span>
            <span className="report-title">Reports for {selectedDomain}</span>
          </div>

          <div className="report-buttons">
            <button className="report-btn" onClick={fetchFullAcquisitionReport}>
              Generate report
            </button>

            <button
              className="report-btn ai-btn"
              disabled={!domainReport}
              onClick={() =>
                downloadAnalysisPDF(
                  `Acquisition Analysis - ${selectedDomain}`,
                  buildAcquisitionPDFContent()
                )
              }
            >
              Download PDF
            </button>
          </div>

          {domainReport && (
            <div className="global-report-box">
              <h4>Global Report</h4>
              <p>
                <strong>Domain:</strong> {domainReport.domain}
              </p>
              <p>
                <strong>Score:</strong> {domainReport.score}
              </p>
              <p>{domainReport.global_message}</p>
            </div>
          )}

          {domainDetailedReport && (
            <div className="detailed-report-box">
              <h4>Detailed Report</h4>

              {domainDetailedReport.length === 0 ? (
                <p>No issues found for this domain.</p>
              ) : (
                domainDetailedReport.map((item, idx) => (
                  <div key={idx} className="detailed-item">
                    <p>
                      <strong>Question:</strong> {item.question}
                    </p>
                    <p>
                      <strong>Answer:</strong> {item.answer}
                    </p>
                    <p>
                      <strong>Suggestion:</strong> {item.suggestion}
                    </p>
                    <hr />
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      )}
    </section>
  );

  const fetchModelReport = useCallback(async () => {
    if (!selectedModel) return;

    try {
      setLoadingScores(true);
      setModelReport(null);

      const mappedKeyword = MODEL_KEYWORDS[selectedModel];
      const response = await fetch(
        `${API_URL}/expert/analyse-pdf-by-name?keyword=${mappedKeyword}`
      );

      if (!response.ok) throw new Error("Erreur lors de lâ€™analyse des modèles.");

      const data = await response.json();
      setModelReport(data);
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingScores(false);
    }
  }, [selectedModel]);

  const ALLOWED_MODEL_KEYWORDS = [
    "functional",
    "process",
    "physical",
    "decisional",
    "information",
  ];

  const filteredGraiModels = graiModels.filter((model) => {
    const name = (model.filename || "").toLowerCase();
    return ALLOWED_MODEL_KEYWORDS.some((keyword) => name.includes(keyword));
  });

  const cleanAI = (text) => {
    if (!text) return "";
    text = text.replace(/```json/gi, "").replace(/```/g, "");

    let obj = null;
    try {
      obj = JSON.parse(text);
    } catch {
      return text;
    }

    let final = "";
    const writeSection = (title, content) => {
      final += `\n\n ${title}\n`;
      if (Array.isArray(content)) content.forEach((item) => (final += `${item}\n`));
      else if (typeof content === "string") final += content + "\n";
      else if (typeof content === "object" && content !== null) {
        Object.entries(content).forEach(([k, v]) => (final += `${k} : ${v}\n`));
      }
    };

    Object.entries(obj).forEach(([key, value]) => {
      const title = key
        .replace(/_/g, " ")
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (c) => c.toUpperCase());
      writeSection(title, value);
    });

    return final.trim();
  };

  const renderModeles = () => (
    <section className="analysis-section">
      <h3 className="section-title">Models</h3>
      <p className="section-subtitle">
        Analyse models using expert rules or AI interpretation.
      </p>

      <div className="model-buttons-grid">
        <button
          className={`model-btn ${modelAnalysisMode === "expert" ? "active" : ""}`}
          onClick={() => setModelAnalysisMode("expert")}
        >
          Expert Structure Analysis
        </button>

        <button
          className={`model-btn ${modelAnalysisMode === "ai" ? "active" : ""}`}
          onClick={() => setModelAnalysisMode("ai")}
        >
          AI PDF Analysis
        </button>
      </div>

      {modelAnalysisMode === "expert" && (
        <>
          <p className="section-subtitle">Select a view to analyse.</p>

          <div className="model-buttons-grid">
            {[
              "Functional View",
              "Process View",
              "Physical View",
              "Decisional View",
              "Information Model",
            ].map((name) => (
              <button
                key={name}
                className={`model-btn ${selectedModel === name ? "active" : ""}`}
                onClick={() => setSelectedModel(name)}
              >
                {name}
              </button>
            ))}
          </div>

          {selectedModel && (
            <div className="report-section">
              <div className="report-header">
                <span className="report-icon"></span>
                <span className="report-title">Expert report for {selectedModel}</span>
              </div>

              <div className="report-buttons">
                <button className="report-btn" onClick={fetchModelReport}>
                  Generate analysis
                </button>
              </div>

              {modelReport && (
                <>
                  <div className="global-report-box">
                    <h4>Model Analysis Summary</h4>
                    <p>
                      <strong>View Type:</strong> {modelReport.view_type}
                    </p>
                    <p>
                      <strong>PDFs analyzed:</strong> {modelReport.pdf_found_count}
                    </p>
                  </div>

                  <div className="report-buttons">
                    <button
                      className="report-btn"
                      onClick={() =>
                        downloadAnalysisPDF(
                          `GRAI Expert Analysis - ${selectedModel}`,
                          JSON.stringify(modelReport, null, 2)
                        )
                      }
                    >
                      Download PDF
                    </button>
                  </div>

                  {Array.isArray(modelReport.results) &&
                    modelReport.results.map((pdf, index) => (
                      <div key={index} className="detailed-report-box">
                        <h4>{pdf.filename}</h4>

                        <p>
                          <strong>Nodes:</strong> {pdf.nodes}
                        </p>
                        <p>
                          <strong>Arrows:</strong> {pdf.arrows}
                        </p>
                        <p>
                          <strong>Total Shapes:</strong> {pdf.total_shapes}
                        </p>
                        <p>
                          <strong>Score:</strong> {pdf.score} / 20
                        </p>
                        <p>
                          <strong>Interpretation:</strong> {pdf.interpretation}
                        </p>

                        <h4>Rules Evaluation</h4>
                        {pdf.rules_evaluation.map((rule, idx) => (
                          <div key={idx} className="detailed-item">
                            <p>
                              <strong>Rule:</strong> {rule.rule}
                            </p>
                            <p>
                              <strong>Status:</strong> {rule.passed ? "âœ… Passed" : "âŒ Failed"}
                            </p>
                            <p>
                              <strong>Detail:</strong> {rule.detail}
                            </p>
                            <hr />
                          </div>
                        ))}
                      </div>
                    ))}
                </>
              )}
            </div>
          )}
        </>
      )}

      {modelAnalysisMode === "ai" && (
        <>
          <p className="section-subtitle">Select a uploaded model (PDF).</p>

          <select
            className="model-select"
            value={selectedModelId || ""}
            onChange={(e) => setSelectedModelId(e.target.value)}
            disabled={filteredGraiModels.length === 0}
          >
            <option value="">
              {filteredGraiModels.length === 0
                ? "-- No valid model available --"
                : "-- Select a model to analyse --"}
            </option>

            {filteredGraiModels.map((model) => (
              <option key={model._id} value={model._id}>
                {model.filename}
              </option>
            ))}
          </select>

          <div className="report-buttons">
            <button
              className="report-btn ai-btn"
              disabled={!selectedModelId}
              onClick={fetchAIModelsAnalysis}
            >
              Generate AI Model Analysis
            </button>
          </div>

          {aiModelsAnalysis && (
            <div className="ai-report-box">
              <h4>AI Interpretation</h4>

              <pre className="ai-clean-text">{cleanAI(aiModelsAnalysis)}</pre>

              <div className="report-buttons">
                <button
                  className="report-btn"
                  onClick={() =>
                    downloadAnalysisPDF("GRAI Model AI Analysis", cleanAI(aiModelsAnalysis))
                  }
                >
                  Download PDF
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </section>
  );

  const fetchManagementReport = useCallback(async () => {
    if (!selectedManagementTool) return;

    try {
      setLoadingScores(true);
      setManagementExpertReport(null);

      const mappedKeyword = MANAGEMENT_KEYWORDS[selectedManagementTool];
      if (!mappedKeyword) return;

      const response = await fetch(
        `${API_URL}/expert/analyse-pdf-by-name?keyword=${mappedKeyword}`
      );

      if (!response.ok) throw new Error("Erreur lors de lâ€™analyse du management.");

      const data = await response.json();
      setManagementExpertReport(data);
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingScores(false);
    }
  }, [selectedManagementTool]);

  const ALLOWED_MANAGEMENT_KEYWORDS = ["vsm", "5s", "kaizen", "smed", "kanban", "visual"];

  const filteredManagementFiles = graiModels.filter((model) => {
    const name = (model.filename || "").toLowerCase();
    return ALLOWED_MANAGEMENT_KEYWORDS.some((keyword) => name.includes(keyword));
  });

  const inferManagementTool = (filename) => {
    const name = (filename || "").toLowerCase();
    if (name.includes("vsm")) return "vsm";
    if (name.includes("5s")) return "5s";
    if (name.includes("kaizen")) return "kaizen";
    if (name.includes("smed")) return "smed";
    if (name.includes("kanban")) return "kanban";
    if (name.includes("visual")) return "visual";
    return null;
  };

  const fetchAIManagementAnalysis = useCallback(async () => {
    if (!activeEnterpriseId || !selectedManagementFileId) return;

    try {
      setLoadingScores(true);
      setManagementAIReport(null);

      const file = filteredManagementFiles.find((f) => f._id === selectedManagementFileId);
      if (!file) {
        setManagementAIReport("âŒ Management file not found.");
        return;
      }

      const toolKey = inferManagementTool(file.filename);
      if (!toolKey) {
        setManagementAIReport("âŒ Unable to detect management type.");
        return;
      }

      const response = await fetch(
        `${API_URL}/api/ai/analyse-management/${activeEnterpriseId}/${toolKey}`
      );

      if (!response.ok) throw new Error("Erreur IA management");

      const data = await response.json();
      setManagementAIReport(data.analysis);
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingScores(false);
    }
  }, [activeEnterpriseId, selectedManagementFileId, filteredManagementFiles]);

  const renderManagements = () => (
    <section className="analysis-section">
      <h3 className="section-title">Managements</h3>
      <p className="section-subtitle">
        Analyse Lean Management either by expert rules or real uploaded documents.
      </p>

      <div className="model-buttons-grid">
        <button
          className={`model-btn ${managementAnalysisMode === "expert" ? "active" : ""}`}
          onClick={() => setManagementAnalysisMode("expert")}
        >
          Expert Structure Analysis
        </button>

        <button
          className={`model-btn ${managementAnalysisMode === "ai" ? "active" : ""}`}
          onClick={() => setManagementAnalysisMode("ai")}
        >
          AI PDF Analysis
        </button>
      </div>

      {managementAnalysisMode === "expert" && (
        <>
          <p className="section-subtitle" style={{ marginTop: "20px" }}>
            Choose a Lean management tool.
          </p>

          <div className="management-buttons-grid">
            {["VSM", "5S", "Kaizen", "SMED", "Kanban", "Visual Management"].map((tool) => (
              <button
                key={tool}
                className={`mgmt-btn ${selectedManagementTool === tool ? "active" : ""}`}
                onClick={() => setSelectedManagementTool(tool)}
              >
                {tool}
              </button>
            ))}
          </div>

          {selectedManagementTool && (
            <div className="report-section">
              <div className="report-header">
                <span className="report-icon"></span>
                <span className="report-title">Reports for {selectedManagementTool}</span>
              </div>

              <div className="report-buttons">
                <button className="report-btn" onClick={fetchManagementReport}>
                  Generate analysis
                </button>
              </div>

              {managementExpertReport && (
                <>
                  <div className="global-report-box">
                    <h4>Management Tool Analysis Summary</h4>
                    <p>
                      <strong>Keyword:</strong> {managementExpertReport.view_type}
                    </p>
                    <p>
                      <strong>PDFs analyzed:</strong> {managementExpertReport.pdf_found_count}
                    </p>
                  </div>

                  <div className="report-buttons">
                    <button
                      className="report-btn"
                      onClick={() =>
                        downloadAnalysisPDF(
                          `Lean Management Expert Analysis - ${selectedManagementTool}`,
                          JSON.stringify(managementExpertReport, null, 2)
                        )
                      }
                    >
                      Download PDF
                    </button>
                  </div>

                  {Array.isArray(managementExpertReport.results) &&
                    managementExpertReport.results.map((pdf, index) => (
                      <div key={index} className="detailed-report-box">
                        <h4>{pdf.filename}</h4>

                        <p>
                          <strong>Nodes:</strong> {pdf.nodes}
                        </p>
                        <p>
                          <strong>Arrows:</strong> {pdf.arrows}
                        </p>
                        <p>
                          <strong>Total Shapes:</strong> {pdf.total_shapes}
                        </p>
                        <p>
                          <strong>Score:</strong> {pdf.score} / 20
                        </p>
                        <p>
                          <strong>Interpretation:</strong> {pdf.interpretation}
                        </p>

                        <h4>Rules Evaluation</h4>
                        {pdf.rules_evaluation.map((rule, idx) => (
                          <div key={idx} className="detailed-item">
                            <p>
                              <strong>Rule:</strong> {rule.rule}
                            </p>
                            <p>
                              <strong>Status:</strong> {rule.passed ? "âœ… Passed" : "âŒ Failed"}
                            </p>
                            <p>
                              <strong>Detail:</strong> {rule.detail}
                            </p>
                            <hr />
                          </div>
                        ))}
                      </div>
                    ))}
                </>
              )}
            </div>
          )}
        </>
      )}

      {managementAnalysisMode === "ai" && (
        <>
          <p className="section-subtitle" style={{ marginTop: "20px" }}>
            Select a real uploaded Lean Management document (PDF).
          </p>

          <select
            className="model-select"
            value={selectedManagementFileId || ""}
            onChange={(e) => setSelectedManagementFileId(e.target.value)}
            disabled={filteredManagementFiles.length === 0}
          >
            <option value="">
              {filteredManagementFiles.length === 0
                ? "-- No management document available --"
                : "-- Select a management to analyse --"}
            </option>

            {filteredManagementFiles.map((file) => (
              <option key={file._id} value={file._id}>
                {file.filename}
              </option>
            ))}
          </select>

          <div className="report-buttons">
            <button
              className="report-btn ai-btn"
              disabled={!selectedManagementFileId}
              onClick={fetchAIManagementAnalysis}
            >
              Generate AI Management Analysis
            </button>
          </div>

          {managementAIReport && (
            <div className="ai-report-box">
              <h4>AI Interpretation</h4>

              <pre className="ai-clean-text">{cleanAI(managementAIReport)}</pre>

              <div className="report-buttons">
                <button
                  className="report-btn"
                  onClick={() =>
                    downloadAnalysisPDF("Lean Management AI Analysis", cleanAI(managementAIReport))
                  }
                >
                  Download PDF
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </section>
  );

  // ==============================
  // âœ… RULES CRUD (API Calls)
  // ==============================
  const fetchRulesCatalog = useCallback(async () => {
    try {
      setRulesLoading(true);
      setRulesError(null);

      const res = await fetch(`${API_URL}/api/rules`, {
        method: "GET",
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });

      if (!res.ok) throw new Error("Impossible de charger la liste des règles.");

      const data = await res.json();
      setRulesCatalog(data.rules || []);
    } catch (e) {
      setRulesError(e.message);
    } finally {
      setRulesLoading(false);
    }
  }, [token]);

  const createRule = useCallback(async () => {
    try {
      setCreateStatus(null);
      setRulesError(null);
      setRulesLoading(true);

      let conditionObj = {};
      try {
        conditionObj = newRule.condition ? JSON.parse(newRule.condition) : {};
      } catch {
        throw new Error("Le champ condition doit àªtre un JSON valide.");
      }

      if (!newRule.rule_type || !newRule.target || !newRule.code || !newRule.title) {
        throw new Error("Merci de remplir: rule_type, target, code, title.");
      }

      const payload = {
        rule_type: newRule.rule_type,
        target: newRule.target.trim().toLowerCase(),
        code: newRule.code.trim().toUpperCase(),
        title: newRule.title,
        description: newRule.description || null,
        condition: conditionObj,
        weight: Number(newRule.weight) || 1.0,
        enabled: Boolean(newRule.enabled),
        created_by: newRule.created_by || null,
      };

      const res = await fetch(`${API_URL}/api/rules`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.detail || data?.message || "Erreur création règle.");

      setCreateStatus("Rule created successfully.");
      await fetchRulesCatalog();

      setNewRule((prev) => ({
        ...prev,
        target: "",
        code: "",
        title: "",
        description: "",
        condition: "{}",
        weight: 1.0,
        enabled: true,
      }));
    } catch (e) {
      setRulesError(e.message);
    } finally {
      setRulesLoading(false);
    }
  }, [token, newRule, fetchRulesCatalog]);

  const loadRuleIntoEditor = useCallback((rule) => {
    if (!rule?._id) return;

    setSelectedRuleId(rule._id);
    setEditRule({
      title: rule.title || "",
      description: rule.description || "",
      condition: JSON.stringify(rule.condition || {}, null, 2),
      weight: rule.weight ?? 1.0,
      enabled: rule.enabled ?? true,
    });

    setUpdateStatus(null);
    setDeleteStatus(null);
  }, []);

  const updateRule = useCallback(async () => {
    if (!selectedRuleId) return;

    try {
      setRulesLoading(true);
      setRulesError(null);
      setUpdateStatus(null);

      let conditionObj = {};
      try {
        conditionObj = editRule.condition ? JSON.parse(editRule.condition) : {};
      } catch {
        throw new Error("Condition (edit) doit àªtre un JSON valide.");
      }

      const payload = {
        title: editRule.title,
        description: editRule.description,
        condition: conditionObj,
        weight: Number(editRule.weight) || 1.0,
        enabled: Boolean(editRule.enabled),
      };

      const res = await fetch(`${API_URL}/api/rules/${selectedRuleId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.detail || data?.message || "Erreur update règle.");

      setUpdateStatus("âœ… Rule updated.");
      await fetchRulesCatalog();
    } catch (e) {
      setRulesError(e.message);
    } finally {
      setRulesLoading(false);
    }
  }, [token, selectedRuleId, editRule, fetchRulesCatalog]);

  const deleteRule = useCallback(async () => {
    if (!selectedRuleId) return;

    try {
      setRulesLoading(true);
      setRulesError(null);
      setDeleteStatus(null);

      const res = await fetch(`${API_URL}/api/rules/${selectedRuleId}`, {
        method: "DELETE",
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.detail || data?.message || "Erreur suppression règle.");

      setDeleteStatus("âœ… Rule deleted.");
      setSelectedRuleId("");
      await fetchRulesCatalog();
    } catch (e) {
      setRulesError(e.message);
    } finally {
      setRulesLoading(false);
    }
  }, [token, selectedRuleId, fetchRulesCatalog]);

  // auto-load when opening Rules tab
  useEffect(() => {
    if (activeTab === "rules") fetchRulesCatalog();
  }, [activeTab, fetchRulesCatalog]);

  // Styles (avoid ReferenceError)
  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #ddd",
    outline: "none",
  };

  const textareaStyle = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #ddd",
    outline: "none",
    resize: "vertical",
  };

  const textareaStyleMono = {
    ...textareaStyle,
    fontFamily: "monospace",
    fontSize: 12,
  };

  const renderRules = () => (
    <section className="analysis-section">
      <h3 className="section-title">Rules</h3>
      <p className="section-subtitle">
        Create and manage expert rules stored in MongoDB (backend: /api/rules).
      </p>

      <div className="report-section">
        <div className="report-header">
          <span className="report-icon"></span>
          <span className="report-title">Create a new rule</span>
        </div>

        <div className="report-buttons">
          <button className="report-btn" onClick={fetchRulesCatalog}>
            Refresh rules list
          </button>
        </div>

        {rulesLoading && <p className="loading-message">Loading...</p>}
        {rulesError && <p className="case-error">{rulesError}</p>}
        {createStatus && <p className="success-message">{createStatus}</p>}

        <div style={{ marginTop: 16, display: "grid", gap: 10 }}>
          <div style={{ display: "grid", gap: 8 }}>
            <label style={{ fontWeight: 600 }}>Rule type</label>
            <select
              className="model-select"
              value={newRule.rule_type}
              onChange={(e) => setNewRule((p) => ({ ...p, rule_type: e.target.value }))}
            >
              <option value="model">model</option>
              <option value="management">management</option>
            </select>
          </div>

          <div style={{ display: "grid", gap: 8 }}>
            <label style={{ fontWeight: 600 }}>Target *</label>
            <input
              value={newRule.target}
              onChange={(e) => setNewRule((p) => ({ ...p, target: e.target.value }))}
              placeholder="ex: functional, process, environmental, cost..."
              style={inputStyle}
            />
          </div>

          <div style={{ display: "grid", gap: 8 }}>
            <label style={{ fontWeight: 600 }}>Code *</label>
            <input
              value={newRule.code}
              onChange={(e) => setNewRule((p) => ({ ...p, code: e.target.value }))}
              placeholder="ex: FV_R1, ESG_R3..."
              style={inputStyle}
            />
          </div>

          <div style={{ display: "grid", gap: 8 }}>
            <label style={{ fontWeight: 600 }}>Title *</label>
            <input
              value={newRule.title}
              onChange={(e) => setNewRule((p) => ({ ...p, title: e.target.value }))}
              placeholder="Short readable title"
              style={inputStyle}
            />
          </div>

          <div style={{ display: "grid", gap: 8 }}>
            <label style={{ fontWeight: 600 }}>Description</label>
            <textarea
              value={newRule.description}
              onChange={(e) => setNewRule((p) => ({ ...p, description: e.target.value }))}
              rows={3}
              style={textareaStyle}
            />
          </div>

          <div style={{ display: "grid", gap: 8 }}>
            <label style={{ fontWeight: 600 }}>Condition (JSON)</label>
            <textarea
              value={newRule.condition}
              onChange={(e) => setNewRule((p) => ({ ...p, condition: e.target.value }))}
              rows={8}
              style={textareaStyleMono}
            />
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div style={{ display: "grid", gap: 8 }}>
              <label style={{ fontWeight: 600 }}>Weight</label>
              <input
                type="number"
                step="0.1"
                value={newRule.weight}
                onChange={(e) => setNewRule((p) => ({ ...p, weight: e.target.value }))}
                style={inputStyle}
              />
            </div>

            <div style={{ display: "grid", gap: 8 }}>
              <label style={{ fontWeight: 600 }}>Enabled</label>
              <select
                className="model-select"
                value={newRule.enabled ? "true" : "false"}
                onChange={(e) => setNewRule((p) => ({ ...p, enabled: e.target.value === "true" }))}
              >
                <option value="true">true</option>
                <option value="false">false</option>
              </select>
            </div>
          </div>

          <div style={{ display: "grid", gap: 8 }}>
            <label style={{ fontWeight: 600 }}>Created by</label>
            <input
              value={newRule.created_by}
              onChange={(e) => setNewRule((p) => ({ ...p, created_by: e.target.value }))}
              placeholder="ex: admin@icam / Emmanuel"
              style={inputStyle}
            />
          </div>

          <div className="report-buttons" style={{ marginTop: 8 }}>
            <button className="report-btn ai-btn" onClick={createRule} disabled={rulesLoading}>
              Create rule
            </button>
          </div>
        </div>
      </div>

      <div className="report-section" style={{ marginTop: 20 }}>
        <div className="report-header">
          <span className="report-icon"></span>
          <span className="report-title">Existing rules</span>
        </div>

        {updateStatus && <p className="success-message">{updateStatus}</p>}
        {deleteStatus && <p className="success-message">{deleteStatus}</p>}

        {rulesCatalog.length === 0 ? (
          <p style={{ opacity: 0.8, marginTop: 10 }}>No rules yet.</p>
        ) : (
          <>
            <div style={{ marginTop: 12 }}>
              <label style={{ fontWeight: 600 }}>Select a rule to edit</label>
              <select
                className="model-select"
                value={selectedRuleId}
                onChange={(e) => {
                  const id = e.target.value;
                  setSelectedRuleId(id);
                  const r = rulesCatalog.find((x) => x._id === id);
                  if (r) loadRuleIntoEditor(r);
                }}
              >
                <option value="">-- Choose a rule --</option>
                {rulesCatalog.map((r) => (
                  <option key={r._id} value={r._id}>
                    {r.code} {r.title} ({r.rule_type}/{r.target})
                  </option>
                ))}
              </select>
            </div>

            {selectedRuleId && (
              <div style={{ marginTop: 16, display: "grid", gap: 10 }}>
                <div style={{ display: "grid", gap: 8 }}>
                  <label style={{ fontWeight: 600 }}>Title</label>
                  <input
                    value={editRule.title}
                    onChange={(e) => setEditRule((p) => ({ ...p, title: e.target.value }))}
                    style={inputStyle}
                  />
                </div>

                <div style={{ display: "grid", gap: 8 }}>
                  <label style={{ fontWeight: 600 }}>Description</label>
                  <textarea
                    value={editRule.description}
                    onChange={(e) => setEditRule((p) => ({ ...p, description: e.target.value }))}
                    rows={3}
                    style={textareaStyle}
                  />
                </div>

                <div style={{ display: "grid", gap: 8 }}>
                  <label style={{ fontWeight: 600 }}>Condition (JSON)</label>
                  <textarea
                    value={editRule.condition}
                    onChange={(e) => setEditRule((p) => ({ ...p, condition: e.target.value }))}
                    rows={8}
                    style={textareaStyleMono}
                  />
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <div style={{ display: "grid", gap: 8 }}>
                    <label style={{ fontWeight: 600 }}>Weight</label>
                    <input
                      type="number"
                      step="0.1"
                      value={editRule.weight}
                      onChange={(e) => setEditRule((p) => ({ ...p, weight: e.target.value }))}
                      style={inputStyle}
                    />
                  </div>

                  <div style={{ display: "grid", gap: 8 }}>
                    <label style={{ fontWeight: 600 }}>Enabled</label>
                    <select
                      className="model-select"
                      value={editRule.enabled ? "true" : "false"}
                      onChange={(e) =>
                        setEditRule((p) => ({ ...p, enabled: e.target.value === "true" }))
                      }
                    >
                      <option value="true">true</option>
                      <option value="false">false</option>
                    </select>
                  </div>
                </div>

                <div className="report-buttons">
                  <button className="report-btn ai-btn" onClick={updateRule} disabled={rulesLoading}>
                    Update rule
                  </button>
                  <button className="report-btn" onClick={deleteRule} disabled={rulesLoading}>
                    Delete rule
                  </button>
                  <button
                    className="report-btn"
                    onClick={() =>
                      downloadAnalysisPDF(
                        `Rule - ${selectedRuleId}`,
                        JSON.stringify(rulesCatalog.find((x) => x._id === selectedRuleId), null, 2)
                      )
                    }
                    disabled={!selectedRuleId}
                  >
                    Download PDF
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );

  // auto-load catalog when tab = rules
  useEffect(() => {
    if (activeTab === "rules") fetchRulesCatalog();
  }, [activeTab, fetchRulesCatalog]);


  // ==============================
  // 8ï¸âƒ£ RENDU FINAL
  // ==============================
  return (
    <>
      <div className="analysis-container">
        <main className="analysis-main">
          <section className="case-header">
            <div className="case-card improved-case-card">
              <h2 className="case-title improved-case-title">
                {activeCase?.company_name || "Active case"}
              </h2>

              <p className="case-subtitle improved-case-subtitle">
                {activeCase ? (
                  <>
                    <span className="case-info-item">
                      Sector :<strong> {activeCase.activity_sector || "N/A"}</strong>
                    </span>

                    <span className="case-divider"></span>

                    <span className="case-info-item">
                      Company size :<strong> {activeCase.company_size || "N/A"}</strong>
                    </span>
                  </>
                ) : (
                  "No case selected"
                )}
              </p>

              {activeCase && (
                <p className="case-created improved-case-created">
                  Created on :{" "}
                  <strong>{activeCase.date_created || activeCase.timestamp || "Unknown date"}</strong>
                </p>
              )}

              <p className="case-id-display improved-case-id">
                Case ID : <strong>{activeCaseId || ""}</strong>
              </p>

              {errorMessage && <p className="case-error improved-case-error">{errorMessage}</p>}
            </div>
          </section>

          {/* Navigation onglets */}
          <section className="tabs-section">
            <button
              className={`tab-button ${activeTab === "acquisition" ? "active" : ""}`}
              onClick={() => setActiveTab("acquisition")}
            >
               Acquisition
            </button>
            <button
              className={`tab-button ${activeTab === "modeles" ? "active" : ""}`}
              onClick={() => setActiveTab("modeles")}
            >
              Models
            </button>
            <button
              className={`tab-button ${activeTab === "managements" ? "active" : ""}`}
              onClick={() => setActiveTab("managements")}
            >
              Managements
            </button>

            {/* âœ… NEW */}
            <button
              className={`tab-button ${activeTab === "rules" ? "active" : ""}`}
              onClick={() => setActiveTab("rules")}
            >
              Rules
            </button>
          </section>

          <section className="analysis-section">
            <h3 className="section-title">Global Case AI Analysis</h3>

            <button className="report-btn ai-btn" onClick={fetchAICaseAnalysis}>
              Analyse full case with AI
            </button>

            {aiCaseAnalysis && (
              <div className="ai-report-box">
                <pre className="ai-clean-text">{cleanAI(aiCaseAnalysis)}</pre>

                <div className="report-buttons">
                  <button
                    className="report-btn"
                    onClick={() =>
                      downloadAnalysisPDF("Global Case AI Analysis", cleanAI(aiCaseAnalysis))
                    }
                  >
                    Download PDF
                  </button>
                </div>
              </div>
            )}
          </section>

          {/* Contenu */}
          {activeTab === "acquisition" && renderAcquisition()}
          {activeTab === "modeles" && renderModeles()}
          {activeTab === "managements" && renderManagements()}
          {activeTab === "rules" && renderRules()}
        </main>
      </div>

      {/* âœ… Navigation */}
      <div className="icam-navigation">
        <Link to="/pdf-uploader">
          <button className="icam-nav-btn">Back to saving</button>
        </Link>
        <Link to="/conception">
          <button className="icam-nav-btn">Move to conception</button>
        </Link>
      </div>
    </>
  );
}

export default Analysis;
